import { Modal } from 'antd';

import { CloseOutlined } from '@ant-design/icons';

import styles from './index.module.scss';
import clsx from 'clsx';

interface ModalFullScreenProps {
  isOpen: boolean;
  onCancel: () => void;
  theme?: 'light' | 'dark';
}

const ModalFullScreen = ({
  children,
  isOpen,
  onCancel,
  theme = 'dark',
}: React.PropsWithChildren<ModalFullScreenProps>) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      wrapClassName={clsx(styles.wrapper, styles[theme])}
      className={styles.modal}
      closable={true}
      closeIcon={<CloseOutlined className={styles.cancelBtn} />}
    >
      <div className={styles.modalContent}>
        <div>{children}</div>
      </div>
    </Modal>
  );
};

export default ModalFullScreen;
